import { z } from "zod";

const quantity = z.string().regex(/^(?:0|[1-9]\d*)(?:\.\d+)?$/);
const isoDate = z.iso.date();
const timestamp = z.iso.datetime({ offset: true });

export const payrollObligationStatusSchema = z.enum(["open", "settled", "cancelled"]);
export type PayrollObligationStatus = z.infer<typeof payrollObligationStatusSchema>;

export const payrollObligationSchema = z
  .object({
    id: z.string().min(1),
    membershipId: z.string().min(1),
    sourceCycleStart: isoDate,
    sourceCycleEnd: isoDate,
    workDate: isoDate,
    session: z.enum(["first", "second"]),
    kind: z.enum(["post_cutoff", "provisional"]),
    status: payrollObligationStatusSchema,
    ownerType: z.enum(["payroll_admin", "system_queue"]),
    ownerId: z.string().min(1),
    provisionalEntitlementUnits: quantity,
    lastRecognizedEntitlementUnits: quantity,
    cutoffDate: isoDate,
    sourceRevision: z.number().int().nonnegative(),
    recognitionRevision: z.number().int().nonnegative(),
    settledAt: timestamp.nullable(),
    createdAt: timestamp,
    updatedAt: timestamp,
  })
  .strict()
  .refine(({ sourceCycleStart, sourceCycleEnd }) => sourceCycleEnd >= sourceCycleStart, {
    message: "The obligation source cycle is invalid.",
  });

export type PayrollObligation = z.infer<typeof payrollObligationSchema>;

export const payrollObligationListSchema = z
  .object({ rows: z.array(payrollObligationSchema), nextCursor: z.string().min(1).nullable() })
  .strict();

export type PayrollObligationList = z.infer<typeof payrollObligationListSchema>;

export const payrollObligationFiltersSchema = z
  .object({
    membershipId: z.string().min(1).optional(),
    status: payrollObligationStatusSchema.optional(),
    cursor: z.string().min(1).optional(),
    limit: z.number().int().min(1).max(100).optional(),
  })
  .strict();

export type PayrollObligationFilters = z.infer<typeof payrollObligationFiltersSchema>;
